// @flow

import type { BasicProps } from '../../type'

import * as React from 'react'
import { appendPropsSchema, appendPropsActions } from '../util/schemaUtil'

type Props = BasicProps & {
  style: ?Object,
  styleCode: ?string
};

export default function (WrappedComponent: React.ComponentType<*>) {
  class CustomStyle extends React.PureComponent<Props> {
    static schema = appendPropsSchema(WrappedComponent);

    wrappedComponent: ?React.Component<*>;

    static actions = appendPropsActions(WrappedComponent);

    render (): React.Node {
      const { styleCode, jsEnv } = this.props
      const style = { ...this.props.style }
      if (styleCode) {
        Object.assign(style, jsEnv.runCode(styleCode))
      }
      return (
        <WrappedComponent
          ref={ref => {
            if (ref) {
              this.wrappedComponent = ref
            }
          }}
          {...this.props}
          style={style}
        />
      )
    }
  }

  return CustomStyle
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/customStyle.js